import { Logger, LogLevel } from './logger.model';
import moment from 'moment';

export class Stopwatch {
  startTime = moment();

  constructor(private logger: Logger, private logLevel: LogLevel = LogLevel.Info, private message?: string, private data?: any) {}

  stop() {
    const duration = moment().diff(this.startTime);
    const timeTakenMilliseconds = moment.duration(duration).asMilliseconds();

    const logData = {
      ...(this.data ?? {}),
      timeTaken: timeTakenMilliseconds
    };

    const message = `${this.message} (${timeTakenMilliseconds})ms`;
    this.logger.logMessage(this.logLevel, message, logData);
  }
}
